import { Button, CircularProgress, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useMemo } from 'react';
import { DataGridStyle } from '../../shared/sharedStyles';

export const QuizsTable = ({ lngsltd, data, courseData, handleEdit, handleDelete, handleAddQuestions }) => {
    const columns = useMemo(() => {
        return [
            { field: 'id', headerName: '#', width: 50, headerAlign: 'center', align: 'center' },
            {
                field: 'courseName', headerName: lngsltd["CourseName"], width: 150, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',               //  required for centering
                        whiteSpace: 'normal',        //  enable wrapping
                        wordBreak: 'break-word',     //  prevent overflow
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'title', headerName: lngsltd["Quiz Title"], width: 200, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'description', headerName: lngsltd["Description"], width: 300, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'actions',
                headerName: lngsltd["Actions"],
                flex: 1,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => (
                    <>
                        <Button variant="outlined" size="small" onClick={() => handleEdit(params.row.quizID)} style={{ marginRight: 8 }}>
                            {lngsltd["Edit"]}
                        </Button>
                        <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(params.row.quizID)} style={{ marginRight: 8 }}>
                            {lngsltd["Delete"]}
                        </Button>
                        <Button variant="outlined" color="secondary" size="small" onClick={() => handleAddQuestions(params.row.quizID)}>
                            {lngsltd["Add Questions"]}
                        </Button>
                    </>
                ),
            }
        ]
    }, []);

    const rows = useMemo(() => {

        const getCourseNameById = (courseId) => {
            const crs = courseData.find((crsdt) => crsdt.courseID === courseId);
            return crs ? crs.courseName : 'No Course';
        };

        return data.map((d, i) => ({
            id: i + 1,
            courseName: getCourseNameById(d.courseID),
            title: d.title,
            description: d.description,
            quizID: d.quizID,
        }))
    }, [data, courseData]);


    if (data.length === 0) {
        return (
            <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                <CircularProgress />
            </Typography>
        );
    }
    return (
        <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            disableColumnResize
            getRowHeight={() => 'auto'}   //  allows dynamic row height for wrapping

            sx={{
                ...DataGridStyle,

                //  Force vertical + horizontal centering for ALL cells
                '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            }}
        />

    );
}

